import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import './Login.css';
import logo from '../../Assest/LogoSingefin.png';
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";


function Login() {
    const urlGetLogin = `${urlApiServer}logins?populate=*`;
    const urlGetUploadFiles = `${urlApiServer}upload/files`;

    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [data, setData] = useState([]);
    const [uploadFiles, setUploadFiles] = useState([]);
    const { infoUser, setInfoUser } = useContext(LoginContext)

    const urlGetLinkingforms = `${urlApiServer}linkingforms?correo=${email}&clave_de_usuario=${password}`;

    useEffect(() => {
        if (infoUser.isLoged === true) {
            window.location.href = './Inicio';
        }
    }, [infoUser])

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                const response = await fetch(urlGetLogin, requestOptions);
                const loginResponse = await response.json();

                if (loginResponse?.data) {
                    console.log('info del login: ', loginResponse.data);
                    setData(loginResponse.data);
                } else {
                    console.log('La API no devolvió datos válidos');
                    setData([]);  // Evita que `data` sea null
                }
            } catch (error) {
                console.log('El backend está temporalmente desactivado', error);
                setData([]);  // Evita que `data` sea null
            }
        })();
    }, [urlGetLogin]);


    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetUploadFiles, requestOptions)
                    .then(response => response.json())
                    .then(imageResponse => {
                        console.log('info de las imagenes: ', imageResponse);
                        setUploadFiles(imageResponse);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();
    }, [urlGetUploadFiles])

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    function headlePassword(e) {
        setPassword(e.target.value); // Para un input tipo número, usa `value`
    }

    async function login() {
        if (email && password) {
            (async function () {
                const startHeaders = new Headers();
                startHeaders.append("Content-Type", "application/json");

                const requestOptions = {
                    method: 'GET',
                    headers: startHeaders,
                    redirect: 'follow',
                };

                try {
                    await fetch(urlGetLinkingforms, requestOptions)
                        .then(response => response.json())
                        .then(LoginResponse => {
                            console.log('info del Linkage: ', LoginResponse.data);
                            // Check if 'data' contains the user information
                            const foundUser = LoginResponse.data && LoginResponse.data.correo === email ? LoginResponse.data : null;

                            if (foundUser) {
                                console.log('foundUser: ', foundUser);
                                const foundImage = uploadFiles.find(images => images.name === foundUser.firma);
                                if (foundImage) {
                                    Swal.fire({
                                        title: "Correcto",
                                        text: `Bienvenido ${foundUser.nombres} ${foundUser.apellidos}`,
                                        icon: "success",
                                        allowOutsideClick: false
                                    }).then(() => {
                                        setInfoUser({
                                            isLoged: true,
                                            usuario: { ...foundUser },
                                            firma: { ...foundImage },
                                        });
                                    });
                                }
                            } else {
                                Swal.fire({
                                    title: "Error",
                                    text: "Asegurate de tener todos los datos completos",
                                    icon: "error",
                                    allowOutsideClick: false
                                });
                            }
                        });
                } catch (error) {
                    console.log('el backend esta temporalmente descativado: ', error);
                    Swal.fire({
                        title: "Error",
                        text: "Asegurate de tener todos los datos completos",
                        icon: "error",
                        allowOutsideClick: false
                    });
                }
            })();
        } else {
            Swal.fire({
                title: "Error",
                text: "Asegurate de tener todos los datos completos",
                icon: "error",
                allowOutsideClick: false
            });
        }
    }

    return (
        <div className="containerLogin">
            <div className="containerBannerLogin">
                <div className="bannerLogin">
                    <div
                        className="imageBannerLogin"
                        style={{
                            backgroundImage: data.length > 0 &&
                                data[0].imagen_portada_inicio_de_sesion?.[0]?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_inicio_de_sesion[0].url})`
                                : "url('../../Assest/temporary/bannerHome.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerLinkage">
                                {data.length > 0 && data[0].texto_portada_inicio_de_sesion ? data[0].texto_portada_inicio_de_sesion : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div >
            <div className="containerInfoLoginSection">
                {data.length > 0 && data[0].texto_inicio_de_sesion ? (
                    data[0].texto_inicio_de_sesion.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoLegalSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textInfoLoginSection">
                                                {child.text}
                                            </p>

                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textInfoLoginSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textInfoLoginSection">...</p>
                )}
            </div>
            <div className="containerFormLoginSection">
                <div className="cardFormnLoginSection">
                    <div className="containerInputsLoginSection">
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsLoginSection elongatedInputs"
                        />
                        <input
                            type="password"
                            name="password"
                            placeholder="contraseña"
                            value={password}
                            onChange={headlePassword}
                            className="inputsLoginSection elongatedInputs"
                        />
                    </div>
                    <div className="buttonFormLogin" onClick={login}>
                        <p className="textFormLogin">ENVIAR</p>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Login